module.exports = __webpack_public_path__ + "static/media/planet-yellow.201ba1e4.svg";